import { createAction } from '@'
import FetchMappingCoverage, { notifyWrite } from './FetchMappingCoverage'
import GetRegionCoverage from './GetRegionCoverage'
import { $regionCoverageQuery } from '../stores'

const describeChanges = data => {
    const parts = []
    if (data.updated_rows) {
        parts.push(`${data.updated_rows} row(s) updated`)
    }
    if (data.inserted) {
        parts.push(`${data.inserted} hotel(s) added`)
    }
    if (data.skipped_existing) {
        parts.push(`${data.skipped_existing} already mapped`)
    }
    if (data.removed) {
        parts.push(`${data.removed} hotel(s) removed`)
    }
    return parts.join(', ') || 'nothing changed'
}

export default createAction('UpdateRegion', async (regionId, body) => {
    const data = await FetchMappingCoverage({
        method: 'PUT',
        path: `/region/${encodeURIComponent(regionId)}`,
        data: body
    })
    const scope = body.supplier_code ? ` (${body.supplier_code})` : ''
    notifyWrite(`Region ${regionId}${scope}: ${describeChanges(data)}`, data)
    const query = $regionCoverageQuery.getState()
    if (query) {
        await GetRegionCoverage(query)
    }
    return data
})
